import { UserStore } from 'en-thrift-internal';
import { DoLotteryRequest } from 'en-thrift-internal/lib/UserStore';
import { BinaryProtocol, TBinaryXmlHttpTransport } from 'evernote-thrift';
import CryptoJS from 'crypto-js';
import { baseUrl } from '../config/env';
import promisify from '../utils/promisify';

function getUserStore() {
  const transport = new TBinaryXmlHttpTransport(`${baseUrl}/edam/user`);
  const protocol = new BinaryProtocol(transport);
  return new UserStore.UserStore.Client(protocol);
}

/**
 * [getMarketingPromotion 页面初始化接口]
 * @param  {[type]} auth             [token]
 * @param  {[type]} deviceIdentifier [设备识别串]
 * @param  {[type]} pid              [活动ID]
 * @return {[type]}                  [description]
 */
export function getMarketingPromotion(auth, deviceIdentifier, pid) {
  return promisify('getMarketingPromotion', c => getUserStore().getMarketingPromotion(auth, deviceIdentifier, pid, c));
}

/**
 * [doLottery 抽奖接口]
 * @param  {[type]} authenticationToken [token]
 * @param  {[type]} consumerKey         [用于统计]
 * @param  {[type]} deviceIdentifier    [设备识别串]
 * @param  {[type]} pid                 [活动ID]
 * @return {[type]}                     [description]
 */
export function doLottery(authenticationToken, consumerKey, deviceIdentifier, pid) {
  const tStamp = Date.now();
  const cryptoData = `${authenticationToken + consumerKey + deviceIdentifier + tStamp + pid}LOTTERY`;
  const signStr = CryptoJS.MD5(cryptoData).toString();

  const lotteryRequest = new DoLotteryRequest({
    authenticationToken,
    consumerKey,
    deviceIdentifier,
    timeStamp: tStamp,
    sign: signStr,
    pid,
  });
  return promisify('doLottery', c => getUserStore().doLottery(lotteryRequest, c));
}

export default {
  getMarketingPromotion,
  doLottery,
};
